import {useContext, useState} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import {atomIconSizes} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import InfoIcon from '@adv-mt/mt-svg-icons/lib/InfoOutline.js'
import TitleBasic, {titleBasicColors, titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {useUtils} from '../../hooks/useUtils.js'
import {PanelFinancingModal} from '../modal/PanelFinancingModal.js'

const BASE_CLASS = 'mt-PanelFinancing'

export const PanelFinancingInstalmentSelector = ({
  handleOnChangeSelectedFare,
  isProfessional,
  loanCalculations,
  selectedFare
}) => {
  const {i18n} = useContext(Context)

  const [modalContentId, setModalContentId] = useState('')
  const {getValueFormated} = useUtils()
  const {calculatorB2cData} = loanCalculations || {}

  const instalmentTitle = isProfessional ? 'COMMON.FEE_FROM' : 'COMMON.FEE'

  const hasFareWithInsuranceData =
    Boolean(calculatorB2cData) && Object.keys(calculatorB2cData?.withInsurance).length > 0
  const hasFareWithoutInsuranceData =
    Boolean(calculatorB2cData) && Object.keys(calculatorB2cData?.withoutInsurance).length > 0

  const formatedFeeWithoutInsurance = hasFareWithoutInsuranceData
    ? getValueFormated(calculatorB2cData?.withoutInsurance?.fee)
    : ''
  const formatedFeeWithInsurance = hasFareWithInsuranceData
    ? getValueFormated(calculatorB2cData?.withInsurance?.fee)
    : ''

  const handleModalClose = () => {
    setModalContentId('')
  }

  const getClassNameInstalmentSelector = id =>
    cx(`${BASE_CLASS}-instalmentSelector`, {
      [`${BASE_CLASS}-instalmentSelector--selected`]: selectedFare === id
    })

  return (
    <div className={`${BASE_CLASS}-instalmentSelectorsContainer`}>
      <TitleBasic
        as={titleBasicTags.h4}
        color={titleBasicColors.currentColor}
        size={titleBasicSizes.xxs}
        title={`${i18n.t(instalmentTitle)}`}
      />
      <div className={`${BASE_CLASS}-instalmentSelectors`}>
        {hasFareWithoutInsuranceData && (
          <div
            className={getClassNameInstalmentSelector(calculatorB2cData?.withoutInsurance?.insuranceId)}
            onClick={() => {
              handleOnChangeSelectedFare(calculatorB2cData?.withoutInsurance?.insuranceId)
            }}
          >
            <TitleBasic
              as={titleBasicTags.h4}
              color={titleBasicColors.currentColor}
              description="No incluye seguro"
              size={titleBasicSizes.xxs}
              title={`${formatedFeeWithoutInsurance}/${i18n.t('COMMON.PLURALS.MONTH', 1).toLowerCase()}*`}
            />
          </div>
        )}
        {hasFareWithInsuranceData && (
          <div className={getClassNameInstalmentSelector(calculatorB2cData?.withInsurance?.insuranceId)}>
            <div
              className={`${BASE_CLASS}-instalmentSelectorValue`}
              onClick={() => {
                handleOnChangeSelectedFare(calculatorB2cData?.withInsurance?.insuranceId)
              }}
            >
              <TitleBasic
                as={titleBasicTags.h4}
                color={titleBasicColors.currentColor}
                description={i18n.t('PANEL_FINANCING.B2C.FARE_SELECTOR_DESCRIPTION', {
                  insuranceName: calculatorB2cData?.withInsurance?.insuranceName
                })}
                size={titleBasicSizes.xxs}
                title={`${formatedFeeWithInsurance}/${i18n.t('COMMON.PLURALS.MONTH', 1).toLowerCase()}*`}
              />
            </div>
            <div className={`${BASE_CLASS}-insuranceInfo`} onClick={() => setModalContentId('fdaInsuranceInfo')}>
              <InfoIcon size={atomIconSizes.small} />
              <span className={`${BASE_CLASS}-insuranceInfoText`}>
                {i18n.t('PANEL_FINANCING.B2C.FARE_SELECTOR_LINK')}
              </span>
            </div>
          </div>
        )}
        {modalContentId !== '' && (
          <PanelFinancingModal
            contentId={modalContentId}
            financingData={loanCalculations}
            onModalClose={handleModalClose}
          />
        )}
      </div>
    </div>
  )
}

PanelFinancingInstalmentSelector.propTypes = {
  handleOnChangeSelectedFare: PropTypes.func,
  isProfessional: PropTypes.string,
  loanCalculations: PropTypes.object,
  selectedFare: PropTypes.number
}
